export default __webpack_public_path__ + "static/media/icon-arrow.8a9e310e.svg";